/**
 * Created by lu on 2018/5/14.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': ['dropdown-wrap', nb.bind('dropdownName')],
        'data-uk-dropdown': '{}',
        // 'data-uk-dropdown':nb.bind('dropdownOpts'),
        $html: [{
            'class': 'btn-dropdown',
            $slot: 'btn'
        }, {
            'class': 'uk-dropdown',
            $slot: 'content'
        }]
    },
    method: {
        init: function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/dropdown/Dropdown.js
// module id = 40
// module chunks = 0 1 3 4 7 8 9 10 12 13 14 15 16 18 19 21 25 26 27 28 30